import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { headerEmpresa } from '../../helpers/headerEmpresa';
import { getEmpresa } from '../../../services/empresaService';

async function ValorEstoquePDF(produtos) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  // ✅ Busca dados da empresa (global)
  const empresa = await getEmpresa();

  const reportTitle = {
    text: 'Relatório de Valor do Estoque',
    fontSize: 15,
    alignment: 'center',
    bold: true,
    margin: [0, 10, 0, 20]
  };

  let totalEstoque = 0;

  const dados = produtos.map((produto) => {
    const estoque = Number(produto.ESTOQUE);
    const compra = Number(produto.COMPRA);
    const venda = Number(produto.VENDA);

    const valorCompra = compra * estoque;
    const valorVenda = venda * estoque;
    const lucro = valorVenda - valorCompra;

    const icms = (lucro * Number(produto.ICMS_IN || 0)) / 100;
    const pis = (lucro * Number(produto.ALI_PIS_DEBITO || 0)) / 100;
    const cofins = (lucro * Number(produto.ALI_COFINS_DEBITO || 0)) / 100;

    totalEstoque += estoque;

    return [
      { text: produto.COD_PRODUTO, fontSize: 9, alignment: 'center' },
      { text: produto.DESCRICAO, fontSize: 9 },
      { text: produto.UNIDADE, fontSize: 9, alignment: 'center' },
      { text: estoque.toFixed(3), fontSize: 9, alignment: 'right' },
      { text: 'R$ ' + valorCompra.toFixed(2), fontSize: 9, alignment: 'right' },
      { text: 'R$ ' + valorVenda.toFixed(2), fontSize: 9, alignment: 'right' },
      { text: 'R$ ' + icms.toFixed(2), fontSize: 9, alignment: 'right' },
      { text: 'R$ ' + pis.toFixed(2), fontSize: 9, alignment: 'right' },
      { text: 'R$ ' + cofins.toFixed(2), fontSize: 9, alignment: 'right' }
    ];
  });

  const tableHeader = [
    { text: 'Código', style: 'tableHeader', alignment: 'center' },
    { text: 'Nome', style: 'tableHeader' },
    { text: 'Un.', style: 'tableHeader', alignment: 'center' },
    { text: 'Estoque', style: 'tableHeader', alignment: 'right' },
    { text: 'Valor Compra', style: 'tableHeader', alignment: 'right' },
    { text: 'Valor Venda', style: 'tableHeader', alignment: 'right' },
    { text: 'ICMS', style: 'tableHeader', alignment: 'right' },
    { text: 'PIS', style: 'tableHeader', alignment: 'right' },
    { text: 'COFINS', style: 'tableHeader', alignment: 'right' }
  ];

  const details = {
    table: {
      headerRows: 1,
      widths: [80, '*', 40, 60, 80, 70, 50, 50, 50],
      body: [
        tableHeader,
        ...dados
      ]
    },
    layout: 'lightHorizontalLines'
  };

  const docDefinitions = {
    pageSize: 'A4',
    pageOrientation: 'landscape',

    // 🔹 margem maior por causa do header global
    pageMargins: [15, 60, 15, 40],

    // ✅ Header reutilizável (empresa + data + hora)
    header: headerEmpresa(empresa),

    content: [
      reportTitle,
      details
    ],

    footer: (currentPage, pageCount) => ({
      text: `${currentPage} / ${pageCount}`,
      alignment: 'right',
      fontSize: 9,
      margin: [0, 10, 20, 0]
    }),

    styles: {
      tableHeader: {
        bold: true,
        fillColor: '#eeeeee',
        color: 'black',
        fontSize: 10,
        margin: [0, 3, 0, 3]
      }
    }
  };

  pdfMake.createPdf(docDefinitions).open();
}

export default ValorEstoquePDF;
